import axios from 'axios';
import { BASE_URL } from 'src/baseUrl';

const Service = axios?.create({
  baseURL: BASE_URL,
  headers: {
    Accept: 'application/json',
    'x-api-key': 'd3d42f9b-5b2b-483b-976a-c4c7e81e9e8e',
  },
});

Service.interceptors.request.use(
  (config: any) => {
    const token: any = window.localStorage.getItem('accessToken');
    if (token) {
      config.headers.authorization = `Bearer ${JSON.parse(token)}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);
export default Service;
